function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { logger as N } from "../../shared-lib/index.js";
import xt from "../common/translations.js";

var lr = /*#__PURE__*/function () {
  function lr(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

    _classCallCheck(this, lr);

    if (this.language = t, null != t && (t = t.toLowerCase()), null != t && null == xt[t]) {
      var _e = t.indexOf("-");

      _e > 0 && (t = t.substring(0, _e));
    }

    if (null == xt[t]) {
      var a = "Braze does not yet have a localization for language " + t + ", defaulting to English. Please contact us if you are willing and able to help us translate our SDK into this language.";
      e ? N.error(a) : N.info(a), t = "en";
    }

    this.language = t;
  }

  _createClass(lr, [{
    key: "get",
    value: function get(t) {
      return xt[this.language][t];
    }
  }, {
    key: "So",
    value: function So() {
      switch (this.language) {
        case "ar":
        case "he":
        case "fa":
          return "rtl";

        default:
          return "ltr";
      }
    }
  }]);

  return lr;
}();

export { lr as default };